import type React from 'react';
import { useEffect, useState } from 'react';
import { StorageAvatar } from '../../components/common/StorageAvatar';
import { getPartner } from '../../services/partnerService';
import type { RecommendedPartner } from '../../types/tender';

interface PartnerLogoAvatarProps {
  partner: RecommendedPartner;
}

const PartnerLogoAvatar: React.FC<PartnerLogoAvatarProps> = ({ partner }) => {
  const [logoUrl, setLogoUrl] = useState<string | undefined>(partner.logoUrl);

  useEffect(() => {
    if (!partner.logoUrl && partner.partnerId) {
      // Try to fetch from partners collection if missing from the tender record
      let isMounted = true;
      const fetchLogo = async () => {
        try {
          const partnerData = await getPartner(partner.partnerId);
          if (partnerData && isMounted && partnerData.logoUrl) {
            setLogoUrl(String(partnerData.logoUrl));
          }
        } catch (_e) {
          // ignore
        }
      };
      fetchLogo();
      return () => {
        isMounted = false;
      };
    }
    return undefined;
  }, [partner.partnerId, partner.logoUrl]);

  return (
    <StorageAvatar
      src={logoUrl}
      alt={partner.companyName}
      variant="square"
      imgProps={{ sx: { objectFit: 'contain' } }}
      sx={{
        width: 40,
        height: 40,
        bgcolor: logoUrl ? 'transparent' : 'primary.main',
        fontSize: '1.25rem',
        color: 'primary.contrastText',
      }}
    >
      {partner.companyName.charAt(0).toUpperCase()}
    </StorageAvatar>
  );
};

export default PartnerLogoAvatar;
